// extracted by mini-css-extract-plugin
export var orderDetails = "_oi-2";
export var orderImage = "_oi-1";
export var orderMeta = "_oi-3";
export var orderSummary = "_oi-0";
export var rightArrow = "_oi-4";